import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ButtonWithIcon from 'chameleon/packages/blue-book-player/library/button-with-icon';
import BlueBookButton from 'chameleon/packages/blue-book-player/library/bluebook-button/BlueBookButton';
import { getQuestionsAnswerState } from 'chameleon/packages/blue-book-player/utils';
import QuestionsReview from 'chameleon/packages/blue-book-player/library/QuestionsReview';
import NavigatorLegend from './NavigatorLegend';

const NavigatorContent = (props) => {
  const [questionsAnswerState, setQuestionsAnswerState] = useState([]);
  const {
    handleClose,
    quizTitle,
    currentQuestionIndex,
    learnosityApp,
    navigateToReviewPage,
  } = props;

  const customItemGoTo = (reference) => {
    learnosityApp?.items()?.goto(reference);
    handleClose(false);
  };

  useEffect(() => {
    const responses = learnosityApp?.getResponses();
    const learnosityItems = learnosityApp?.getItems();
    const questions = Object.keys(learnosityItems || {});

    setQuestionsAnswerState(
      getQuestionsAnswerState(learnosityItems, questions, responses),
    );
  }, [learnosityApp]);

  const POPOVER_HEADER_CLASSES =
    'mx-[3px] border-b border-bluebook-gray4 py-[8px] flex justify-around flex-row';

  const onNavigateToReviewPage = () => {
    navigateToReviewPage();
    handleClose();
  };

  return (
    <div
      className="px-[21px] max-w-[495px] text-center"
      aria-label="Question Menu"
      role="region"
    >
      <div className={POPOVER_HEADER_CLASSES}>
        <div className="leading-[1.16] text-[19px] text-center py-[12px] px-[5px] font-bold grow-[2] shrink-[1] basis-0">
          {quizTitle + ' Questions'}
        </div>
        <div className="flex items-center w-[16px]">
          <ButtonWithIcon
            isIcon
            isNaked
            icon="close"
            iconWidth={20}
            iconHeight={20}
            aria-label="Close Popup"
            onClick={handleClose}
            className="relative"
          />
        </div>
      </div>

      <div className={POPOVER_HEADER_CLASSES}>
        <NavigatorLegend showCurrentLegend />
      </div>

      <div className="py-[12px] max-h-[500px] overflow-auto">
        <QuestionsReview
          questions={questionsAnswerState}
          currentQuestionIndex={currentQuestionIndex}
          isCompact
          itemGoTo={customItemGoTo}
        />
        <BlueBookButton
          onClick={onNavigateToReviewPage}
          isSecondary
          className="py-[3px] px-[18px] !font-bold mt-[18px] mb-[7px]"
        >
          Go to Review Page
        </BlueBookButton>
      </div>
    </div>
  );
};

NavigatorContent.propTypes = {
  handleClose: PropTypes.func,
  quizTitle: PropTypes.string,
  currentQuestionIndex: PropTypes.number,
  learnosityApp: PropTypes.object,
};

NavigatorContent.defaultProps = {
  handleClose: () => {},
  quizTitle: '',
  currentQuestionIndex: -1,
  learnosityApp: null,
};

export default NavigatorContent;
